"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketPolicyInput_1 = require("./DeleteBucketPolicyInput");
var DeleteBucketPolicyOutput_1 = require("./DeleteBucketPolicyOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketPolicy = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketPolicy",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?policy"
    },
    input: {
        shape: DeleteBucketPolicyInput_1.DeleteBucketPolicyInput
    },
    output: {
        shape: DeleteBucketPolicyOutput_1.DeleteBucketPolicyOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketPolicy.js.map